import actions from "@state/actions";
import { Dispatch } from "redux";
import * as actionInterfaces from './types';

export const getDealerCollections = (dispatch: Dispatch, collectionsRequest: actionInterfaces.IGetCollections) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.dealers.getDealerCollections(collectionsRequest, (result: any, error: any) => {
      if (error) reject(error);
      else resolve(result);
    }));
  });
}

export const getDealerAssets = (dispatch: Dispatch, assetsRequest: actionInterfaces.IGetAssets) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.dealers.getDealerAssets(assetsRequest, (result: any, error: any) => {
      if (error) reject(error);
      else resolve(result);
    }));
  });
}

export const getDealerAssetsNames = (dispatch: Dispatch, assetsRequest: actionInterfaces.IGetAssetsNames) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.dealers.getDealerAssetsNames(assetsRequest, (result: any, error: any) => {
      if (error) reject(error);
      else resolve(result);
    }));
  });
}

export const GetUserByPrimaryDealer = (dispatch: Dispatch, primaryDealerId: string) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.dealers.getExtDealerByIdAPI(primaryDealerId, (result: any, error: any) => {
      if (error) reject(error);
      else resolve(result.data);
    }));
  });
}